import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.less']
})
export class MainLayoutComponent implements OnInit {

  constructor(public router: Router) { }

  ngOnInit(): void {
    localStorage.removeItem('newUser');
    console.log(this.router.url)
  }

  showNewHeaderFooter() {
    if (this.router.url.includes("/home") || this.router.url === '') {
      return true;
    } else {
      return false;
    }
  }

  showOldHeaderFooter() {
    if (!this.router.url.includes("/home") && this.router.url !== '') {
      return true;
    } else {
      return false;
    }
  }

  getActiveClass() {
    const element = document.getElementById("main-header");
    if(element) {
      if (this.router.url.includes("/home") || this.router.url === '') {
        return '';
      } else {
        return {
          'margin-top' : element.offsetHeight + 'px',
          'min-height': '100vh'
        }
      }
    }
  }

}
